//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { RightsRequestCommunicationType } from '@apis/rights-management/rightsManagementApiModels';
import PartialCuid from '@models/PartialCuid';
import { isDefined } from '@utils/filterPredicates';

const INSTAGRAM_OAUTH2_AUTHORIZE_URL =
  'https://api.instagram.com/oauth/authorize';

export const enum OAuthLandingPageMessageType {
  OAuthCheckPassed = 'RightsRequestOAuthCheckPassed',
  OAuthCancelled = 'RightsRequestOAuthCancel',
  OAuthCheckFailed = 'RightsRequestOAuthCheckFailed',
}

export interface OAuthLandingPageSuccessMessage {
  type:
    | OAuthLandingPageMessageType.OAuthCancelled
    | OAuthLandingPageMessageType.OAuthCheckPassed;
}

export interface OAuthLandingPageErrorMessage {
  type: OAuthLandingPageMessageType.OAuthCheckFailed;
  error: string;
}

export type OAuthLandingPagePostMessage =
  | OAuthLandingPageSuccessMessage
  | OAuthLandingPageErrorMessage;

export interface RequestRightsOAuthParams {
  approvalPhrase?: string;
  communicationType?: RightsRequestCommunicationType;
  itemId: PartialCuid;
  requestMessage?: string;
  targetUrl?: string;
}

export const getInstagramOAuthUrl = (itemParams: RequestRightsOAuthParams) => {
  const itemParamString = encodeURIComponent(JSON.stringify(itemParams));
  const redirectUri = `${location.origin}/rights-request-oauth-landing`;

  const params = new URLSearchParams({
    client_id: CURALATE_ENV.INSTAGRAM_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'user_profile',
    state: itemParamString,
  });

  return `${INSTAGRAM_OAUTH2_AUTHORIZE_URL}?${params.toString()}`;
};

export const isOAuthMessage = (type?: OAuthLandingPageMessageType) => {
  if (!isDefined(type)) {
    return false;
  }

  switch (type) {
    case OAuthLandingPageMessageType.OAuthCheckPassed:
    case OAuthLandingPageMessageType.OAuthCancelled:
    case OAuthLandingPageMessageType.OAuthCheckFailed:
      return true;
    default:
      return false;
  }
};
